module.exports = __webpack_public_path__ + "img/noimage.1728ab53.svg";